import React, { useCallback, useMemo, useRef } from 'react';
import { useModal } from '../../../hooks/useModal';
import CustomModal from '../../baseComponents/gui/customModal/CustomModal';
import CustomButton from '../../features/customButton/ui/main/CustomButton';
import Icon from '../../baseComponents/gui/icon/Icon';
import { useContent } from '../../../redux/reducer/content';
import { image } from '../../../utils/data/baseUrl';
import { safeHTML } from '../../../utils/safeHTML';
import { useCopy } from '../../../hooks/useCopy';
import Scrollbar from 'react-scrollbars-custom';
import { compilationScrollbarSettings } from '../../../constants/copyright';
import Reward from '../../baseComponents/gui/reward/Reward';
import classNames from 'classnames';
import { giftModal } from '../../../constants/copyright-modals';
import { checkOnGoToShopBtn } from '../../../utils/helpers';
import { fromTimeStampFull } from '../../../utils/helpers/helpers';
import { gtmFunctions } from '../../../constants/analytics/GTM';
import { useTranslation } from '../../../translations';
import { useLanguageControls } from '../../../hooks/useLanguageControls';

const WinModal = React.forwardRef(function WinModal(
  {
    linkBtn,
    mod,
    text,
    title,
    description,
    note,
    list,
    buttons,
    price,
    gifts,
    img,
    extraImg,
    reward,
    func,
    promocode,
    link,
    selection,
    noXP,
    score,
    terms_of_use,
    promocodeImg,
    callbacks,
    isNoImg = false,
    selfClose,
    created_at,
    expired_at,
    expired_promo,
    isWheelPromo,
    className,
    isHideScroll,
  },
  ref,
) {
  const { closeModal, id } = useModal();
  const { t } = useTranslation();
  const { price: money } = useContent();
  const [buttonText, setButtonText, disabled] = useCopy(promocode);
  const promoCodeRef = useRef(null);
  const { isArabic } = useLanguageControls();
  const { termOfUseText } = giftModal;

  const coins = price || money;
  text = text || t('gameWinModalContent.text');
  title = title || t('gameWinModalContent.title');

  const _reward = useMemo(
    () => ({
      type: promocode ? 'promo' : reward ? 'energy' : 'coin',
      value: reward || price,
    }),
    [price, reward],
  );

  const close = useCallback(() => {
    func?.();
    selfClose ? closeModal({ id }) : closeModal({ type: 'all' });
  }, []);

  const isScroll = selection || ['task', 'gifts'].includes(mod);

  return (
    <CustomModal>
      <div
        className={classNames(`win-modal`, className, {
          'win-modal_scroll': isScroll,
          [`win-modal_${mod}`]: mod,
          [`win-modal_date`]: created_at,
        })}
        ref={ref}
      >
        <div className={'win-modal__bg'} onClick={close} />
        <div className={'win-modal__content'}>
          {isScroll && !isHideScroll ? (
            <Scrollbar {...compilationScrollbarSettings}>{getContent()}</Scrollbar>
          ) : (
            getContent()
          )}
          {isWheelPromo && (
            <div className='win-modal__expired-promo'>
              <div className='win-modal__date-text'>
                {safeHTML(t('other.expiredAtWithValue', { value: fromTimeStampFull(expired_promo, isArabic) }))}
              </div>
            </div>
          )}
        </div>
      </div>
    </CustomModal>
  );

  function getContent() {
    return (
      <>
        {created_at && (
          <div className={'win-modal__date'}>
            <div className={'win-modal__date-text'}>
              {safeHTML(t('other.getted') + '&nbsp;')}
              {fromTimeStampFull(created_at, isArabic)}
            </div>
            {expired_at && (
              <div className={'win-modal__date-text'}>
                {safeHTML(t('other.expiredAtWithValue', { value: fromTimeStampFull(expired_at, isArabic) }))}
              </div>
            )}
          </div>
        )}
        {!isNoImg && (
          <div className={classNames('win-modal__image', { 'win-modal__image_task': mod === 'task' })}>
            {mod === 'task' ? (
              promocodeImg ? (
                <img src={promocodeImg} alt={'img'} />
              ) : (
                <Reward {..._reward} mod={'win'} />
              )
            ) : img ? (
              <img src={img.includes('htt') ? img : img.includes('images') ? img : image(img)} alt={'img'} />
            ) : (
              <img src={image('salut.png')} alt={'img'} />
            )}
          </div>
        )}

        <div className='win-modal__info'>
          <h2 className='win-modal__title'>{safeHTML(mod === 'task' ? t('other.taskComplete') : t(title))}</h2>
          {!title && promocode && (
            <div className={'win-modal__promocode'}>
              <span ref={promoCodeRef}>{promocode}</span>
              <CustomButton
                disabled={disabled}
                className={'custom-button_min custom-button_copy'}
                text={buttonText}
                onClick={setButtonText}
              />
            </div>
          )}
          {!noXP && score && score !== 0 && (
            <div className='win-modal__hp'>
              <div className='win-modal__hp-title'>{safeHTML(`+${score}XP`)}</div>
              <div className='win-modal__hp-text'>{safeHTML(t('other.toRating'))}</div>
            </div>
          )}
          {description && mod !== 'task' && <p className='win-modal__text'>{safeHTML(t(description))}</p>}
          {note && mod === 'task' && <p className='win-modal__note'>{safeHTML(t(note))}</p>}
          {(coins || gifts || (reward && mod !== 'task')) && (
            <div className={'win-modal__prizes'}>
              {coins && coins !== 0 && (
                <div className={'win-modal__prize win-modal__prize_1'} key={'win-modal__prize_1'}>
                  <Icon name={'coin-g'} />
                  <span>+{coins}</span>
                </div>
              )}
              {reward && reward !== 0 && mod !== 'task' && (
                <div className={'win-modal__prize win-modal__prize_2'} key={'win-modal__prize_2'}>
                  <Icon name={'energy-g'} />
                  <span>+{reward}</span>
                </div>
              )}
              {gifts && gifts !== 0 && mod !== 'task' && (
                <div className={'win-modal__prize win-modal__prize_1'} key={'win-modal__prize_1'}>
                  {/* <Icon name={"gift-coin"}/> */}
                  <span>+{gifts} гифтов</span>
                </div>
              )}
            </div>
          )}
          {title && promocode && (
            <div className='win-modal__promocode'>
              <span ref={promoCodeRef}>{promocode}</span>
              <CustomButton
                disabled={disabled}
                className={'custom-button_min custom-button_copy custom-button_gray'}
                text={buttonText}
                onClick={setButtonText}
              />
            </div>
          )}

          {description && mod === 'task' && <p className='win-modal__text'>{safeHTML(t(description))}</p>}

          {link?.href && (
            <a href={link.href} target={'_blank'} className='win-modal__link' rel='noreferrer'>
              {safeHTML(t(link.text))}
            </a>
          )}

          {terms_of_use && (
            <a href={terms_of_use} target={'_blank'} className='win-modal__link' rel='noreferrer'>
              {safeHTML(t(termOfUseText))}
            </a>
          )}

          <div className={'win-modal__buttons'}>
            {buttons ? (
              buttons.map((item, id) => (
                <CustomButton
                  key={`CustomButton-${id}`}
                  {...item}
                  {...(linkBtn && [item, item?.attr].some((el) => el?.tag === 'a') && { href: linkBtn })}
                  onClick={() => {
                    checkOnGoToShopBtn(item, promocode, t) && gtmFunctions.GTMGoToShopAfterPrize();
                    item?.callback && callbacks[item.callback](item?.callbackOptions);
                    close();
                  }}
                />
              ))
            ) : (
              <CustomButton
                className={'win-modal__button button_win'}
                text={text === t('gameWinModalContent.text') ? t('winInfo.button.text') : text}
                onClick={close}
              />
            )}
          </div>
          {!!selection?.length && (
            <div className='win-modal__selection'>
              <img src={image('procedureResult/arrow.svg')} className={'win-modal__arrow'} />
              <div className='win-modal__selection-title'>{safeHTML(t('other.yourSelection'))}</div>
              <div className='win-modal__selection-list'>
                {selection.map((item, index) => (
                  <div className='win-modal__selection-item' key={index}>
                    <div className='win-modal__selection-item-image'>
                      <img src={item.image} alt={'img'} />
                    </div>
                    <div className='win-modal__selection-item-name'>{safeHTML(item?.title)}</div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </>
    );
  }
});
export default WinModal;
WinModal.propTypes = {};
